import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "attendance-calendar bg-white mr-4 mb-4 overflow-hidden w-full" }
const _hoisted_2 = { class: "attendance-calendar-row flex" }

import { ref, watch } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import listPlugin from '@fullcalendar/list';
import { useAttendanceStore } from '@/store';
import { storeToRefs } from 'pinia';

import { CalendarEventInterface, TherapyResultsInterface } from '@/types';

interface ArgumentInterface {
  event: CalendarEventInterface;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityAttendanceCalendarList',
  setup(__props) {

const AttendanceStore = useAttendanceStore();
const { therapyResults, start_at, end_at } = storeToRefs(AttendanceStore);
const primeCalendar = ref();

/**
 * Transform string into kebab-case
 *
 * Input example: IEP Meeting
 * Output example: iep-meeting
 *
 * @param str
 */
function convertToKebabCase(str: string) {
  if (!str) {
    return '';
  }

  return str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('-');
}

function getTherapyResultData() {
  const events: CalendarEventInterface[] = [];

  therapyResults.value.map((result: TherapyResultsInterface) => {
    events.push({
      title: result.therapy_result_type?.name,
      classNames: [
        result.therapy_result_type?.is_present ? 'attended' : 'no-show',
        convertToKebabCase(result.event.therapy_event_type),
      ],
      start: new Date(result.event.start_at),
      end: new Date(result.event.end_at),
      editable: false,
      extendedProps: {
        description: result.notes,
      },
    });
  });

  if (!primeCalendar.value) {
    return events;
  }

  const calendar = primeCalendar.value.getApi();
  calendar.removeAllEvents();
  calendar.addEventSource(events);
}

const calendarOptions = ref({
  plugins: [listPlugin],
  initialView: 'list',
  visibleRange: {
    start: start_at.value + 'T00:00:00',
    end: end_at.value + 'T23:59:59',
  },
  headerToolbar: false,
  listDayFormat: { month: 'numeric', day: 'numeric', year: 'numeric' },
  stickyHeaderDates: false,
  listDaySideFormat: false,
  height: '100%',
  eventBackgroundColor: '#ffffff',
  eventBorderColor: '#f1f3f3',
  eventTextColor: '#3B4242',
  eventMinHeight: 24,
  events: getTherapyResultData(),
  eventContent: function (arg: ArgumentInterface) {
    let title = document.createElement('span');
    title.innerHTML = arg.event.title;
    title.className = 'white-space-nowrap';

    let arrayOfDomNodes = [title];
    return { domNodes: arrayOfDomNodes };
  },
});

watch(therapyResults, () => {
  getTherapyResultData();
  calendarOptions.value.visibleRange = {
    start: start_at.value + 'T00:00:00',
    end: end_at.value + 'T23:59:59',
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FullCalendar), {
        ref_key: "primeCalendar",
        ref: primeCalendar,
        options: calendarOptions.value,
        class: "flex-1 w-full border-0"
      }, null, 8, ["options"])
    ])
  ]))
}
}

})